import { knownPromotions } from '@utils/algolia/urlIsKnownFilter';
import {
  getFilterLabel,
  getCategorySlugsFromUrl,
} from '@utils/algolia/getCategorySlugsFromUrl';
import { DEALSREGEX } from '@utils/plp/constants';

// For promotions (sale, clearance etc) we want to programatically filter those variants
export const getPromotionFilters = (url: string, locale = 'en') => {
  const { categoryFilters } = getCategorySlugsFromUrl(url, locale);
  const lastUrlFilter = categoryFilters ? categoryFilters.at(-1) : '';
  const lastUrlFilterLabel = getFilterLabel(lastUrlFilter || '');

  const dealsRegex = new RegExp(DEALSREGEX);
  const isDeals = url?.match(dealsRegex);

  const dealsFilters: { [key: string]: string[] } = {
    en: [`promotions:'Sale'`, `promotions:'Clearance'`],
    fr: [`promotions:'Economisez'`, `promotions:'Liquidation'`],
  };

  const isPromotion =
    (lastUrlFilter &&
      knownPromotions[locale || 'en'].includes(lastUrlFilter)) ||
    false;

  const promotionFilters = isDeals
    ? dealsFilters[locale]
    : [`promotions:'${lastUrlFilterLabel}'`];

  const promotionFilter = ` AND (${promotionFilters.join(' OR ')})`;

  return isPromotion ? promotionFilter : '';
};
